import { defineComponent, ref, watch, onMounted, onBeforeUnmount, createElementBlock, openBlock, createElementVNode, createBlock, createCommentVNode, unref, computed, Fragment, withDirectives, normalizeStyle, toDisplayString, withCtx, normalizeClass, createVNode, vShow } from "vue";
import { Observable, translation, TJSLambdaType, ObjectList, AnchorPosition, ScalarBarWidget, ScalarBar, DynamicGUIComponent, DynamicPrevNext, parseMenuItems, setupVtkOverrides, DocumentContext, useReactivity, provideProjectContext, uploadObjectToContext } from "@xlabmedical/medic-web-engine";
import { useNavbar, ButtonEnum, useResizeObserver } from "@xlabmedical/medic-web-framework";
import ProgressBar from "primevue/progressbar";
const _hoisted_1$2 = {
  class: "flex flex-col h-full horizontal-padding",
  style: { "margin-bottom": "1rem", "margin-top": "1rem", "min-height": "0" }
};
const _hoisted_2$1 = {
  class: "grow overflow-x-hidden overflow-y-auto",
  style: { "min-height": "0" }
};
const _hoisted_3$1 = { style: { "flex": "0 0 auto" } };
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "AppWizard",
  props: {
    context: {},
    hidePrevNext: { type: Boolean },
    hideObjectList: { type: Boolean },
    hideCADToolbars: { type: Boolean },
    showScalarBarWidget: { type: Boolean },
    wizardType: {},
    initializeLambda: { type: Function },
    finalizeLambda: { type: Function },
    cleanupLambda: { type: Function }
  },
  emits: ["nextStepNested", "previousStepNested"],
  setup(__props, { emit: __emit }) {
    let widgetsOrder = ref([]);
    let widgets = void 0;
    let title = ref("");
    const fRef = ref(Math.random());
    let tabWidgetHandler = ref();
    let objectTreeModel;
    const wizardContainer = ref(null);
    const props = __props;
    props.context.setHideCADToolbars(props.hideCADToolbars ?? false);
    watch(
      () => props.hideCADToolbars,
      (newVal) => {
        props.context.setHideCADToolbars(newVal ?? false);
      }
    );
    const viewSize = new Observable([0, 0]);
    const emits = __emit;
    let navBar = void 0;
    onMounted(async () => {
      props.context.showLoading(translation("shared.loadingWizard", { wizard: props.wizardType }), false, void 0, true);
      props.context.setCADMode(true);
      try {
        navBar = useNavbar();
        navBar.enableNavbarButtons([ButtonEnum.UNDO, ButtonEnum.REDO]);
      } catch (e) {
        console.warn("Error enabling navbar buttons: ", e);
      }
      const container = document.getElementById("wizard-container");
      if (container) props.context.contextCAD.setOverlayContainer(container);
      setupGUILambda();
      setupViewSizeObserver();
      if (props.finalizeLambda) {
        props.context.contextCAD.GetMainForm().SetJSLambda(props.finalizeLambda, TJSLambdaType.eJSLT_FINALIZE_CAD_WIZARD);
      } else {
        const finalizeCADWizard = (apply) => {
          setTimeout(() => {
            props.context.setCADMode(false);
            if (apply) {
              emits("nextStepNested");
            } else {
              emits("previousStepNested");
            }
          }, 300);
        };
        props.context.contextCAD.GetMainForm().SetJSLambda(finalizeCADWizard, TJSLambdaType.eJSLT_FINALIZE_CAD_WIZARD);
      }
      if (props.initializeLambda) await props.initializeLambda();
      if (!props.hideObjectList) {
        setupObjectList();
      }
      if (props.showScalarBarWidget) {
        setupScalarBarWidget();
      }
      tabWidgetHandler.value = props.context.contextCAD.tabWidgetHandler;
      props.context.hideLoading();
    });
    onBeforeUnmount(() => {
      var _a;
      (_a = props.context.contextCAD.overlayComponents) == null ? void 0 : _a.cleanup();
      if (navBar) {
        navBar == null ? void 0 : navBar.disableNavbarButtons([ButtonEnum.UNDO, ButtonEnum.REDO]);
      }
      try {
        props.context.contextCAD.GetMainForm().ClearJSLambda(TJSLambdaType.eJSLT_RETIEVE_GUI);
        props.context.contextCAD.GetMainForm().ClearJSLambda(TJSLambdaType.eJSLT_UPDATE_OBJECT_TREE_LIST);
        props.context.contextCAD.GetMainForm().ClearJSLambda(TJSLambdaType.eJSLT_UPDATE_CONTACTS_WIDGET);
        props.context.contextCAD.GetMainForm().ClearJSLambda(TJSLambdaType.eJSLT_FINALIZE_CAD_WIZARD);
        props.context.setCADMode(false);
        if (props.cleanupLambda) props.cleanupLambda();
        props.context.setTabIndex(1);
      } catch (e) {
        console.error("Error during unmount: ", e);
      }
    });
    function setupGUILambda() {
      props.context.contextCAD.GetMainForm().SetJSLambda((toolWidget) => {
        if (!toolWidget) {
          widgetsOrder.value = [];
          widgets = void 0;
          title.value = "";
        } else {
          widgetsOrder.value = toolWidget.GetWidgetOrder().slice();
          widgets = toolWidget.GetWidgets();
          title.value = toolWidget.GetToolTitle();
        }
        fRef.value = Math.random();
      }, TJSLambdaType.eJSLT_RETIEVE_GUI);
    }
    function resizeFcn() {
      const viewContainer = document.getElementById("vtkContainerCAD");
      const rect = viewContainer == null ? void 0 : viewContainer.getBoundingClientRect();
      if (!rect) return;
      const wiz = viewContainer;
      if (wiz) {
        const children = Array.from(wiz.children);
        const firstViewDiv = children.find((child) => child instanceof HTMLDivElement && child.style.display !== "none");
        if (firstViewDiv instanceof HTMLDivElement) {
          const r = firstViewDiv.getBoundingClientRect();
          viewSize.set([r.width, r.height]);
          return;
        }
      }
      viewSize.set([rect.width * 2 / 3, rect.height]);
    }
    function setupViewSizeObserver() {
      wizardContainer.value = document.getElementById("wizard-container");
      const wizardRect = wizardContainer.value ? wizardContainer.value.getBoundingClientRect() : { width: 100, height: 100 };
      viewSize.set([Math.min(100, (wizardRect == null ? void 0 : wizardRect.width) * 2 / 3), Math.min(100, wizardRect == null ? void 0 : wizardRect.height)]);
      useResizeObserver(wizardContainer, resizeFcn);
    }
    function getObjectListItems() {
      try {
        const wasmItems = props.context.contextCAD.GetMainForm().GetWasmObjectListItems();
        const uniqueGroups = [];
        for (let i = 0; i < wasmItems.size(); i++) {
          const it = wasmItems.get(i);
          const group = it.GetGroup();
          if (!uniqueGroups.includes(group)) {
            uniqueGroups.push(group);
          }
        }
        const items = [];
        for (let i = 0; i < uniqueGroups.length; i++) {
          const groupItems = [];
          for (let j = 0; j < wasmItems.size(); j++) {
            const it = wasmItems.get(j);
            if (uniqueGroups[i] === it.GetGroup()) {
              const c = it.GetColor();
              groupItems.push({
                key: it.GetId(),
                label: it.GetLabel(),
                visible: it.GetState(),
                color: [c.get(0), c.get(1), c.get(2)],
                onClick: (key) => {
                  props.context.contextCAD.GetMainForm().WasmObjectListItemClicked(key, true);
                },
                onSelect: (key) => {
                  props.context.contextCAD.GetMainForm().WasmObjectListItemClicked(key, true);
                },
                onUnselect: (key) => {
                  props.context.contextCAD.GetMainForm().WasmObjectListItemClicked(key, false);
                }
              });
            }
          }
          items.push({
            key: uniqueGroups[i],
            label: uniqueGroups[i],
            children: groupItems
          });
        }
        return { items };
      } catch (e) {
        console.error("Error in getObjectListItems", e);
        return { items: [] };
      }
    }
    function updateObjectListItems() {
      objectTreeModel.set(getObjectListItems());
    }
    function getContextMenuItems(key) {
      const menuItems = props.context.contextCAD.GetMainForm().WasmObjectListContextMenuClicked(key);
      return parseMenuItems(menuItems);
    }
    function setupObjectList() {
      var _a;
      objectTreeModel = new Observable({ items: [] });
      (_a = props.context.contextCAD.overlayComponents) == null ? void 0 : _a.createVueOverlayComponent(
        ObjectList,
        {
          objectTree: objectTreeModel,
          viewSize,
          initialPosition: AnchorPosition.topRight,
          getContextMenuItems
        },
        {
          noContainerResize: true
        }
      );
      props.context.contextCAD.GetMainForm().SetJSLambda((resize) => {
        if (resize) {
          resizeFcn();
        } else {
          updateObjectListItems();
        }
      }, TJSLambdaType.eJSLT_UPDATE_OBJECT_TREE_LIST);
      updateObjectListItems();
      resizeFcn();
    }
    function setupScalarBarWidget() {
      var _a;
      const scalarBarWidget = (_a = props.context.contextCAD.overlayComponents) == null ? void 0 : _a.createVueOverlayComponent(
        ScalarBarWidget,
        {
          viewSize,
          barSize: new Observable([220, 100]),
          initialPosition: AnchorPosition.bottomRight,
          // initialPosition: AnchorPosition.topRight,
          onWheelCallback: () => {
            props.context.contextCAD.GetMainForm().WasmScalarBarSetScalarBarScale(ScalarBar.getActiveScalarBarScale());
          },
          headerButtonClicked: (flag) => {
            props.context.contextCAD.GetMainForm().WasmScalarBarHeaderButtonClicked(flag);
          },
          contactsButtonClicked: (flag) => {
            props.context.contextCAD.GetMainForm().WasmScalarBarContactsButtonClicked(flag);
          }
          // parent: context.getOverlayContainer(),
          // dockEvent: () => {
          //     context.dockOverlays();
          // },
        },
        {
          noContainerResize: true
        }
      );
      scalarBarWidget == null ? void 0 : scalarBarWidget.setEnabled(false);
      const updateContactsWidget = (mode, title2, hint, visible, contactsButtonVisible, contactsButtonChecked, headerButtonVisible, headerButtonChecked, reverse) => {
        console.log("Update Contacts Widget", mode, title2, hint, visible, contactsButtonVisible, contactsButtonChecked, headerButtonVisible, headerButtonChecked, reverse);
        ScalarBar.updateTitle(title2);
        scalarBarWidget == null ? void 0 : scalarBarWidget.setEnabled(visible);
        ScalarBar.sReverseGradient.set(reverse);
        ScalarBar.sHint.set(hint);
        ScalarBar.setActiveScalarBarMode(mode);
      };
      props.context.contextCAD.GetMainForm().SetJSLambda(
        (mode, title2, hint, visible, contactsButtonVisible, contactsButtonChecked, headerButtonVisible, headerButtonChecked, reverse, resize) => {
          if (!resize) {
            updateContactsWidget(mode, title2, hint, visible, contactsButtonVisible, contactsButtonChecked, headerButtonVisible, headerButtonChecked, reverse);
          }
        },
        TJSLambdaType.eJSLT_UPDATE_CONTACTS_WIDGET
      );
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$2, [
        createElementVNode("div", _hoisted_2$1, [
          unref(widgetsOrder).length ? (openBlock(), createBlock(unref(DynamicGUIComponent), {
            key: fRef.value,
            "widget-params": unref(widgets),
            "widget-order": unref(widgetsOrder),
            "tool-title": unref(title),
            class: "mb-2"
          }, null, 8, ["widget-params", "widget-order", "tool-title"])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_3$1, [
          unref(tabWidgetHandler) && !props.hidePrevNext ? (openBlock(), createBlock(unref(DynamicPrevNext), {
            key: 0,
            "tab-handler": unref(tabWidgetHandler),
            context: props.context,
            onNextStepNested: _cache[0] || (_cache[0] = ($event) => emits("nextStepNested")),
            onPreviousStepNested: _cache[1] || (_cache[1] = ($event) => emits("previousStepNested"))
          }, null, 8, ["tab-handler", "context"])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
const _hoisted_1$1 = {
  id: "wizard-container",
  style: { display: "flex", flexDirection: "column", minHeight: 0, minWidth: 0 }
};
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "AppView",
  props: {
    context: {}
  },
  setup(__props) {
    const props = __props;
    const vtkContainerCAD = ref();
    onMounted(async () => {
      var _a;
      const wE = await props.context.getEngineInstance();
      setupVtkOverrides(wE);
      props.context.setCADRootElement(vtkContainerCAD.value);
      await ((_a = props.context.contextCAD) == null ? void 0 : _a.LoadCADResources());
    });
    onBeforeUnmount(() => {
      if (props.context) {
        props.context.cleanup();
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$1, [
        createElementVNode("div", {
          ref_key: "vtkContainerCAD",
          ref: vtkContainerCAD,
          id: "vtkContainerCAD",
          style: { "width": "100%", "height": "100%", "flex-grow": "1", "overflow": "hidden", "position": "relative" }
        }, null, 512)
      ]);
    };
  }
});
const _hoisted_1 = { style: { "text-align": "center", "color": "white", "text-shadow": "0 1px 1px black" } };
const _hoisted_2 = {
  class: "mt-20",
  style: { "width": "20vw" }
};
const _hoisted_3 = {
  key: 0,
  style: { "color": "white" }
};
const _hoisted_4 = {
  key: 0,
  id: "wizardTabContainer",
  class: /* @__PURE__ */ normalizeClass("card-no-bottom-padding no-radius bg-body-wiz h-full flex flex-col"),
  style: { flexGrow: 1, minWidth: 0, display: "flex", flexDirection: "column", minHeight: 0 }
};
const _hoisted_5 = {
  class: "h-full web-rg-wizard",
  style: { "margin": "0 0.5rem" }
};
const _hoisted_6 = {
  class: "h-full flex flex-col",
  style: { "position": "relative" }
};
const _hoisted_7 = {
  class: "flex flex-col overflow-x-hidden overflow-y-auto h-full grow",
  id: "wizardBody"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AppContent",
  setup(__props) {
    const loaded = ref(false);
    const loadingFlag = ref(true);
    const progressBarFlag = ref(false);
    const progressBarValue = ref(0);
    const nonTransparent = ref(false);
    const loadingText = ref("Loading project");
    const progressBarRefresh = ref(Math.random());
    const loadingBackground = computed(() => {
      return !nonTransparent.value ? "rgba(91, 91, 91, 0.5)" : "linear-gradient(to top, rgb(40, 106, 173) 1%, rgb(11, 14, 26) 105%)";
    });
    const selectedId = ref("testObject");
    let context = new DocumentContext("");
    const reactivity = useReactivity();
    reactivity.watch(context.loadingFlag, (flag) => {
      loadingFlag.value = flag;
      loadingText.value = context.loadingText;
      progressBarFlag.value = context.progressBarFlag;
      progressBarValue.value = context.progressBarValue.get();
      nonTransparent.value = context.nonTransparentLoading.get();
    });
    onMounted(async () => {
      provideProjectContext(context);
      await context.getEngineInstance();
      const response = await fetch("resources/testObject.obj");
      const blob = await response.blob();
      const file = new File([blob], "testObject.obj", {
        type: blob.type,
        lastModified: (/* @__PURE__ */ new Date()).getTime()
      });
      const stl = await uploadObjectToContext([file], context, "testObject");
      if (stl) selectedId.value = stl.id;
      loadingFlag.value = false;
      loaded.value = true;
    });
    onBeforeUnmount(() => {
      reactivity.cleanupAll();
    });
    async function selectObject() {
      var _a;
      if (selectedId.value.length > 0) {
        const found = await ((_a = context.contextCAD.GetMainForm()) == null ? void 0 : _a.setEditObjectAsync(selectedId.value));
        if (!found) {
          console.log("Object not found in CAD context", selectedId.value);
        }
      }
    }
    const initializeLambda = async () => {
      await context.contextCAD.showSTLEditWizard(true);
      await selectObject();
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        loadingFlag.value ? (openBlock(), createElementBlock("div", {
          key: 0,
          id: "loadingDiv",
          class: "flex flex-col gap-6 items-center justify-center",
          style: normalizeStyle({
            position: "absolute",
            inset: "0px",
            background: loadingBackground.value,
            pointerEvents: "all",
            cursor: "wait",
            zIndex: "100000"
          })
        }, [
          createElementVNode("div", _hoisted_1, toDisplayString(loadingText.value), 1),
          createElementVNode("div", _hoisted_2, [
            (openBlock(), createBlock(unref(ProgressBar), {
              value: progressBarValue.value,
              key: progressBarRefresh.value,
              style: { "height": "2rem" },
              mode: progressBarFlag.value ? "determinate" : "indeterminate"
            }, {
              default: withCtx(() => [
                progressBarFlag.value ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(progressBarValue.value.toFixed(0)) + " %", 1)) : createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["value", "mode"]))
          ])
        ], 4)) : createCommentVNode("", true),
        withDirectives(createElementVNode("div", {
          class: normalizeClass(["flex", "bg-top-nav-bar-wiz bg-body-wiz h-full"]),
          id: "mainContainer",
          ref: "root",
          style: { paddingBottom: "0.5rem" }
        }, [
          loaded.value ? (openBlock(), createElementBlock("div", _hoisted_4, [
            createElementVNode("div", _hoisted_5, [
              createElementVNode("div", _hoisted_6, [
                createElementVNode("div", _hoisted_7, [
                  createVNode(_sfc_main$2, {
                    context: unref(context),
                    "initialize-lambda": initializeLambda
                  }, null, 8, ["context"])
                ])
              ])
            ])
          ])) : createCommentVNode("", true),
          createVNode(_sfc_main$1, {
            context: unref(context),
            style: { "flex-grow": "15" }
          }, null, 8, ["context"])
        ], 512), [
          [vShow, loaded.value]
        ])
      ], 64);
    };
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const AppContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-d284fd31"]]);
export {
  AppContent,
  _sfc_main$1 as AppView,
  _sfc_main$2 as AppWizard
};
//# sourceMappingURL=web-cad-platform.js.map
